// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3korQ","row":"Node_row__15EY1","label":"Node_label__22EoW","footer":"Node_footer__2YOdx"};